import React from 'react'
import widgetFollowUpMeetingStatusHoc, { WidgetFollowUpMeetingStatusHocProps } from './my-follow-up-meetings-prospects-widget-hoc'
import { DashBoardWidget } from '../dashboard-widget'
import { AnalyticDashboardWidget } from 'crm-types'

export const WidgetFollowUpMeetingProspectSummary: React.ComponentType<AnalyticDashboardWidget> = widgetFollowUpMeetingStatusHoc(
  (props: WidgetFollowUpMeetingStatusHocProps) => (
    <DashBoardWidget
      avgDataPassedMonth={props.avgFollowUpMeetingThreeMonth}
      avgDataPassedMonthPerPerson={props.avgFollowUpMeetingPersonPassedMonth}
      avgPerPersonNumber={props.avgFollowUpMeetingCurrentMonthPerPerson}
      footerName={props.footerName}
      footerRender={props.threeMonthAgoFollowUpMeeting}
      isLoading={props.isLoading}
      refetch={props.refetchData}
      secondFooterName={props.footerNamePerPerson}
      secondFooterRender={props.avgFollowUpMeetingPassedMonthData}
      subtitleSecondBlock='Month date average'
      title='Follow Up Meetings - Prospects'
      totalNumber={props.totalFollowUpMeeting}
      onClickDetail={props.onClickDetail}
      subtitle={props.mainCaption}
    />
  )
)
